// Query-key factory. ONE place that owns cache-key shape.
//
// Keys are hierarchical so invalidation can be coarse or precise:
//   qk.reference()          invalidates every reference query
//   qk.users()              invalidates every user query (all search terms)
//   qk.users('ann')         invalidates exactly one search
//
// Rule: never inline a literal key array at a call site. If it isn't in this
// file, the next person invalidating by prefix will silently miss it.

const REFERENCE = 'reference';
const WORK_ITEM = 'work-item';

export const qk = {
  /** Prefix for every schema/directory reference query. */
  reference: () => [REFERENCE],

  fields: (siteUrl = null) => [REFERENCE, 'fields', siteUrl ?? null],
  statuses: (siteUrl = null) => [REFERENCE, 'statuses', siteUrl ?? null],
  issueLinkTypes: (siteUrl = null) => [REFERENCE, 'issue-link-types', siteUrl ?? null],
  priorities: () => [REFERENCE, 'priorities'],
  issueTypes: () => [REFERENCE, 'issue-types'],
  projects: () => [REFERENCE, 'projects'],

  /** Directory lookups. `query` '' is the full list — the common mount case. */
  // scope = a field-scoped picker's { fieldId, project…, issueTypeId, issueKey }:
  // each field's allowed users are their own cache entry.
  users: (query = '', scope = null) => (scope && scope.fieldId ? [REFERENCE, 'users', query, scope] : [REFERENCE, 'users', query]),
  /** The @-mention list — active staff only; a different answer from users(). */
  mentionableUsers: (query = '') => [REFERENCE, 'mentionable-users', query],
  groups: (query = '') => [REFERENCE, 'groups', query],

  fieldOptions: (fieldId, projectKey = null, issueTypeId = null, issueKey = null) =>
    [REFERENCE, 'field-options', fieldId, projectKey, issueTypeId, issueKey],

  createMeta: (projectKey, issueTypeId) =>
    [REFERENCE, 'create-meta', projectKey, issueTypeId],

  /** Prefix for work-item data — the namespace the socket invalidates. */
  workItems: () => [WORK_ITEM],
  workItem: (issueKey) => [WORK_ITEM, 'detail', issueKey],
};
